import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_74: FaireProductEntity = {
  token: "starter_collection_74",
  type: "product",
  name: "Sardines with Hot Pepper",
  brandName: "Fishwife",
  imageUrl:
    '"https://cdn.faire.com/fastly/b44e77540cd8ca08710e2fb434e1581c9b689fe91b424d6e93a9679b2c7b9a59.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=983',
  priceDollars: 10,
  msrpDollars: 20,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
